import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { ErrorFallback } from "components/atoms";
import { ErrorBoundary } from "react-error-boundary";
import Login from "App/Page/Login";
import Wrapper from "App/Component/layout/Wrapper/Wrapper";
import { ProtectedRoutes } from "routes";
import "./styles/global.scss";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ClosePrint from "pages/ClosePrint";
import { isSSO } from "App/constants";
import PrintLabelManual from "pages/PrintLabelManual";

function App() {
  if (isSSO) {
    return (
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Router>
          <Switch>
            <ProtectedRoutes path='/' exact>
              <Wrapper />
            </ProtectedRoutes>
            <Route path='/close-print'>
              <ClosePrint />
            </Route>
            <Route path='/print-label-manual'>
              <PrintLabelManual />
            </Route>
            <Route path='*' exact={true}>
              <p>404</p>
            </Route>
          </Switch>
        </Router>
        <ToastContainer />
      </ErrorBoundary>
    );
  } else {
    return (
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Router>
          <Switch>
            <Route path='/' exact>
              <Login />
            </Route>
            <ProtectedRoutes path='/dashboard' exact>
              <Wrapper />
            </ProtectedRoutes>
            <Route path='/close-print'>
              <ClosePrint />
            </Route>
            <Route path='/print-label-manual'>
              <PrintLabelManual />
            </Route>
            <Route path='*' exact={true}>
              <p>404</p>
            </Route>
          </Switch>
        </Router>
        <ToastContainer />
      </ErrorBoundary>
    );
  }
}

export default App;
